<lib-session-best-block [focal]="focal()" [tiles]="tiles()" />

<sz-button variant="primary" [fullWidth]="true" (click)="openSheetForAdd()">
  <sz-icon name="plus" [size]="16" />
  {{ 'session.runEntry.addRunCta' | translate }}
</sz-button>

<sz-section-head
  [label]="'session.runEntry.recentLabel' | translate"
  [count]="'session.runEntry.tapToEdit' | translate" />

<lib-session-rep-list [rows]="rows()" (runEdit)="openSheetForEdit($event)" (runDelete)="deleteRun($event)" />

<lib-numpad-sheet
  [open]="sheetOpen()"
  [variant]="sheetVariant()"
  [mode]="sheetMode()"
  [context]="sheetContext()"
  [initialPayload]="sheetInitialPayload()"
  [resetTrigger]="sheetResetTrigger()"
  (close)="closeSheet()"
  (submitRun)="onSheetSubmit($event)"
  (deleteRun)="onSheetDelete()" />
